import { Fragment } from 'react'
import { Helmet } from 'react-helmet'
import PageTitle from '@components/PageTitle'
import Layout from '@layout/Main'
import TableBanks from './TableBanks'

function ManageBank() {
  return (
    <Fragment>
      <Helmet>
        <title>
          SQUIDS :: Manajemen Bank
        </title>
      </Helmet>
      <PageTitle>
        Manajemen Bank
      </PageTitle>
      <Layout>
        <TableBanks />
      </Layout>
    </Fragment>
  )
}

export default ManageBank
